<script>
import Base from '@backend/Base.vue';
import BoConfig from '@config/BoConfig.js';
import BOGen from '@helper/BOGen.js';

export default {
  extends: Base,
  data(){
    return {
      Name:"MovementList",
      PageName: "Movement",
      ObjectName: "Movement",
      input: {
        status : "A"
      },
      WithLimit: true,
      row : {},
      mrRequestFor : []
    }
  },
  computed:{
  },
  mounted(){
    this.$set(this.$root, 'page', this)
    this.refreshData()

    this.checkMenuMovement()
  },
  methods:{
    changeType(){
      if(!this.filter.ai_mrf_id){
        let query = Object.assign({}, this.$route.query);
        delete query.ai_mrf_id;
        this.$router.replace({ query });
      } else {
        this.search()
      }
    },
   submitForm(e){
      swal({
        title: "Are you sure to submit?",
        text:"",
        icon: "warning",
        buttons: ["No, Cancel!", "Yes, Sure!"],
        // dangerMode: true,
      }).then((ok) => {
        if(!ok) return;
        if(this.loadingOverlay) return;
        this.loadingOverlay = true
        this.input.request_number = this.row.ai_request_number
        BOGen.apirest("/AppApproval", this.input, (err, resp)=>{
          this.loadingOverlay = false
          if(err) return console.error(err)
          swal("Data has been submitted", "", "success").then(()=>{
            this.$router.push({name:"MovementList"})
          })
        }, "POST")
      })
    },
    checkMenuMovement(){
      const menu = this.user.al_access_menu

      setTimeout(() => { 
        if(this.row.ai_status == "MNG" && this.row.aa.aa_manager_cwid != this.user.cwid && this.user.al_name == "Manager" && menu.indexOf("MovementList") < 0){
          return this.$router.push({name:"Dashboard"})
        }
       }, 1000)
    }
  },
  watch:{
    '$route.query'(v){
      this.refreshData()
    },
  }
}

</script>

<template>
  <div class="container-fluid">
    <div class="row page-titles align-items-center">
      <div class="col-md-5">
        <h4 class="text-themecolor">{{PageName}}</h4>
      </div>
      <div class="col-md-7 tr" v-if="user.emp.access_level == 10 || user.emp.access_level == 1 || user.al_access_menu.indexOf('MovementList')">
        <div class="btn-group">
          <router-link :to="{name:'MovementInit'}" class="btn btn-outline-success" v-tooltip="'Add '+ObjectName">
            <i class="fa fa-plus"></i><span> Add</span>
          </router-link>
        </div>
      </div>
    </div>
    <div class="card" v-if="!$route.params.id">
      <div class="card-body card-filter">
        <VForm @resp="search">
          <div class="row">
            <div class="col-sm-3">
              <h4 class="card-title">{{ObjectName}} List <span v-if="data.total">({{(data.total||0).format()}})</span></h4>
            </div>
            <div class="col-sm-3">
              <Select2 name="ai_mrf_id" url="/request-for-select?type=movement" :object="['mrf_id','mrf_name']" v-model="filter.ai_mrf_id" @input="changeType">
                <option value="">-- All Request For --</option>
              </Select2>
            </div>
            <div class="col-sm-2">
              <Select2 :options="BoConfig.mrPageLimit" v-model="filter.limit"></Select2>
            </div>
            <div class="col-sm-3">
              <div class="has-feedback has-feedback-left">
                <input type="search" v-model="filter.search" class="form-control" placeholder="Type and hit Enter">
                <div class="form-control-feedback">
                  <i class="icon-search4 text-size-base text-muted"></i>
                </div>
              </div>
            </div>
            <div class="col-sm-1">
              <button type="button" @click="resetSearch()" class="btn btn-warning btn-sm">Reset</button>
            </div>
          </div>
        </VForm>
      </div>
      <div class="table-responsive ajax-table">
        <table class="table table-striped table-hover table-bordered mb-0">
          <thead>
            <tr>
              <th>#</th>
              <th>Req. For</th>
              <th>Req. By</th>
              <th>Employee Name</th>
              <th>Request Date</th>
              <th>Department</th>
              <th>Position Title</th>
              <th>Cost Center SAP</th>
              <th>Approval</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(v,k) in data.data" :key="k">
              <td class="number">{{(data.per_page*(data.current_page-1))+k+1}}</td>
              <td>{{v.ai_request_for}}</td>
              <td>{{ v.request_by }}</td>
              <td>{{v.ai_employee_name}}</td>
              <td>{{(v.ai_created_at||"").dates("format2")}}</td>
              <td>
                <span v-tooltip="'Old Department'">{{ v.ai_old_departement || '-' }}</span><i class="icon-arrow-right"></i><span v-tooltip="'New Department'" class="text-info font-weight-bold">{{ v.department || '-' }}</span>
              </td>
              <td>
                <span v-tooltip="'Old Position'">{{ v.ai_old_job_title || '-' }}</span><i class="icon-arrow-right"></i><span v-tooltip="'New Position'" class="text-info font-weight-bold">{{ v.position || '-' }}</span>
              </td>
              <td>
                <span v-tooltip="'Old Cost Center'">{{ v.ai_old_costcenter || '-' }}</span><i class="icon-arrow-right"></i><span v-tooltip="'New Cost Center'" class="text-info font-weight-bold">{{ v.costcenter || '-' }}</span>
              </td>
              <td>
                <template v-if="v.ai_old_msg_id !== v.ai_msg_id">
                  <template>
                    <label v-if="v.aa.aa_manager_status == 'D'" :class="'label label-warning'"  v-tooltip="'Old Manager'" >Pending</label>
                    <label v-else-if="v.aa.aa_manager_status == 'R'" :class="'label label-danger'"  v-tooltip="'Old Manager'" >Rejected</label>
                    <label v-else-if="v.aa.aa_manager_status == 'A'" :class="'label label-success'"  v-tooltip="'Old Manager'" >Approved</label>
                  </template>
                  <template>
                    <label v-if="v.aa.aa_nmanager_status == 'D' && v.aa.aa_manager_status !== 'R'" :class="'label label-warning'"  v-tooltip="'New Manager'" >Pending</label>
                    <label v-else-if="v.aa.aa_nmanager_status == 'R'" :class="'label label-danger'"  v-tooltip="'New Manager'" >Rejected</label>
                    <label v-else-if="v.aa.aa_nmanager_status == 'A'" :class="'label label-success'"  v-tooltip="'New Manager'" >Approved</label>
                  </template>
                </template>
                <template v-else>
                  <label v-if="v.aa.aa_nmanager_status == 'D' && v.aa.aa_manager_status !== 'R'" :class="'label label-warning'"  v-tooltip="'Manager'" >Pending</label>
                  <label v-else-if="v.aa.aa_nmanager_status == 'R'" :class="'label label-danger'"  v-tooltip="'Manager'" >Rejected</label>
                  <label v-else-if="v.aa.aa_nmanager_status == 'A'" :class="'label label-success'"  v-tooltip="'Manager'" >Approved</label>
                </template>
              </td>
              <td class="btn-action">
                <template v-if="v.ai_status == 'MNG' && v.aa.aa_manager_cwid == user.cwid">
                  <router-link class="icon_action" :to="{name:Name,params:{id:v.id}}" v-tooltip="'Approval'"><i class="ti-settings"></i></router-link>
                </template>
                <template v-else-if="v.ai_status == 'NMNG' && v.aa.aa_nmanager_cwid == user.cwid">
                  <router-link class="icon_action" :to="{name:Name,params:{id:v.id}}" v-tooltip="'Approval'"><i class="ti-settings"></i></router-link>
                </template>
                <template v-else>
                  <router-link class="icon_action" :to="{name:Name,params:{id:v.id}}" v-tooltip="'View'"><i class="ti-eye"></i></router-link>
                </template>
              </td>              
            </tr>
            <tr v-if="NotFound">
              <td colspan="99">
                <h3 class="tc">{{NotFound}}</h3>
              </td>
            </tr>
            <tr v-if="data.data===false">
              <td colspan="99">
                <LoadingSpinner light></LoadingSpinner>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="card-body">
        <div class="pull-right">
          <Pagination :data="data" :limit="3" @pagination-change-page="onPaging"></Pagination>
        </div>
      </div>
    </div>
    <div class="card" v-else>
      <VForm @resp="submitForm" method="post">
      <div class="card-body">
        <router-link class="btn btn-outline-info btn-sm mb-3" :to="{ name: 'MovementList' }">
          <i class="icon-arrow-left mr-1"></i>
          Back to Movement List
        </router-link>
        <h4 class="card-title">{{user.emp.access_level == 6 ? "Movement Approval" : "Detail Movement"}}</h4>
        <div class="row">
          <div class="col-md-12">
            <div class="row row-gutter">
              <div class="col-md-3">
                <div class="detail-info">
                  <strong>Effective Join Date</strong>
                  <span v-if="row.ai_effective_join_date">{{ moment(row.ai_effective_join_date).format('DD MMM YYYY') }}</span>
                  <span v-else>-</span>
                </div>
              </div>
              <div class="col-md-3">
                <div class="detail-info">
                  <strong>IPIN</strong>
                  <span>{{ row.fromEmp && (row.fromEmp.IPIN || "-") }}</span>
                </div>
              </div>
              <div class="col-md-3">
                <div class="detail-info">
                  <strong>Employee Name</strong>
                  <span>{{ row.fromEmp && row.fromEmp.employeename }}</span>
                </div>
              </div>
              <div class="col-md-3">
                <div class="detail-info">
                  <strong>Position Title</strong>
                  <span>{{ row.fromEmp && row.fromEmp.position }}</span>
                </div>
              </div>
              <div class="col-md-3">
                <div class="detail-info">
                  <strong>CWID</strong>
                  <span>{{ row.fromEmp && row.fromEmp.cwid }}</span>
                </div>
              </div>
              
              <div class="col-md-3">
                <div class="detail-info">
                  <strong>Email</strong>
                  <span>{{ row.fromEmp && row.fromEmp.email }}</span>
                </div>
              </div>

              <div class="col-md-3" v-if="false">
                <div class="detail-info">
                  <strong>Manager</strong>
                  <span>{{row.dept && row.dept.manager}} || {{ row.dept && row.dept.manager_name }}</span>
                </div>
              </div>

              <div class="col-md-3">
                <div class="detail-info">
                  <strong>Old Employee Cost Center</strong>
                  <span>{{ row.ai_old_costcenter||"-" }}</span>
                </div>
              </div>

              <div class="col-md-3">
                <div class="detail-info">
                  <strong>Employee Cost Center</strong>
                  <span>{{ row.costcenter }}</span>
                </div>
              </div>
              
              <div class="col-md-3">
                <div class="detail-info">
                  <strong>Old Position</strong>
                  <span>{{ row.ai_old_job_title||"-" }}</span>
                </div>
              </div>
              <div class="col-md-3">
                <div class="detail-info">
                  <strong>New Position</strong>
                  <span>{{ row.position||"-" }}</span>
                </div>
              </div>

              <div class="col-md-3">
                <div class="detail-info">
                  <strong>Old Department</strong>
                  <span>{{ row.ai_old_departement||"-" }}</span>
                </div>
              </div>
              <div class="col-md-3">
                <div class="detail-info">
                  <strong>New Department</strong>
                  <span>{{ row.ai_department||"-" }}</span>
                </div>
              </div>
              <template v-if="row.ai_superior || row.ai_old_superior">
                <div class="col-md-3">
                  <div class="detail-info">
                    <strong>Old Superior</strong>
                    <span>{{ row.oldsuperior && row.oldsuperior.cwid ? row.oldsuperior.cwid + " | " + row.oldsuperior.employeename : "-" }}</span>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="detail-info">
                    <strong>New Superior</strong>
                    <span>{{ row.superior && row.superior.cwid ? row.superior.cwid + " | " + row.superior.employeename : "-" }}</span>
                  </div>
                </div>
              </template>
              
              <div class="col-md-3">
                <div class="detail-info">
                  <strong>Employee Category</strong>
                  <span>{{ row.fromEmp && row.fromEmp.mws_id == "1" ? 'Employee' : 'Outsource'}}</span>
                </div>
              </div>

              <template v-if="row.ai_old_msg_id !== row.ai_msg_id">
                <template>
                <div class="col-md-3">
                    <div class="detail-info">
                      <strong>Old Manager Approval</strong>
                      <label v-if="row.aa && row.aa.aa_manager_status == 'D'" :class="'label label-warning'"  v-tooltip="'Old Manager'" >Pending</label>
                      <label v-else-if="row.aa && row.aa.aa_manager_status == 'R'" :class="'label label-danger'"  v-tooltip="'Old Manager'" >Rejected</label>
                      <label v-else-if="row.aa && row.aa.aa_manager_status == 'A'" :class="'label label-success'"  v-tooltip="'Old Manager'" >Approved</label>
                    </div>
                  </div>
                </template>
                <template>
                  <div class="col-md-3">
                    <div class="detail-info">
                      <strong>New Manager Approval</strong>
                      <label v-if="row.aa && row.aa.aa_nmanager_status == 'D' && row.aa.aa_manager_status !== 'R'" :class="'label label-warning'"  v-tooltip="'New Manager'" >Pending</label>
                      <label v-else-if="row.aa && row.aa.aa_nmanager_status == 'R'" :class="'label label-danger'"  v-tooltip="'New Manager'" >Rejected</label>
                      <label v-else-if="row.aa && row.aa.aa_nmanager_status == 'A'" :class="'label label-success'"  v-tooltip="'New Manager'" >Approved</label>
                      <label v-else> - </label>
                    </div>
                  </div>
                </template>
              </template>
              <template v-else>
                <template>
                  <div class="col-md-3">
                    <div class="detail-info">
                      <strong>Manager Approval</strong>
                      <label v-if="row.aa && row.aa.aa_nmanager_status == 'D' && row.aa.aa_manager_status !== 'R'" :class="'label label-warning'"  v-tooltip="'Manager'" >Pending</label>
                      <label v-else-if="row.aa && row.aa.aa_nmanager_status == 'R'" :class="'label label-danger'"  v-tooltip="'Manager'" >Rejected</label>
                      <label v-else-if="row.aa && row.aa.aa_nmanager_status == 'A'" :class="'label label-success'"  v-tooltip="'Manager'" >Approved</label>
                      <label v-else> - </label>
                    </div>
                  </div>
                </template>
              </template>
              
              <template>
                <div class="col-md-3">
                  <div class="detail-info">
                    <strong>Remarks</strong>
                    <span 
                      v-if="
                      (row.aa && row.aa.aa_nmanager_remarks) || 
                      (row.aa && row.aa.aa_manager_remarks)
                    ">
                      {{ row.aa.aa_nmanager_remarks||row.aa.aa_manager_remarks||"-" }}
                    </span>

                    <span v-else>
                      {{ row.ai_remarks }}
                    </span>
                  </div>
                </div>
              </template>


              <!-- approval awal old departement-->
              <div class="col-md-6 offset-md-6" v-if="row.ai_status == 'MNG' && row.aa.aa_manager_cwid == user.cwid">
                <div class="card border">
                  <div class="card-body">
                    <h5 class="card-title">Movement Approval</h5>
                    <div class="form-group">
                      <div class="custom-control custom-radio custom-control-inline">
                        <input
                          type="radio"
                          id="approveMove"
                          class="custom-control-input"
                          value="A"
                          v-model="input.status"
                        >
                        <label
                          class="custom-control-label"
                          for="approveMove">Approve Movement
                        </label>
                      </div>
                      <div class="custom-control custom-radio custom-control-inline">
                        <input
                          type="radio"
                          id="rejectMove"
                          class="custom-control-input"
                          value="R"
                          v-model="input.status"
                        >
                        <label
                          class="custom-control-label"
                          for="rejectMove">Reject Movement
                        </label>
                      </div>
                    </div>
                    <div class="form-group" v-if="input.status == 'R'">
                      <label>Remarks <small class="txt_mandatory">*</small></label>
                      <textarea v-model="input.remarks" minlength="3" class="form-control" rows="5" :required="input.status == 'R' ? true : false"></textarea>
                    </div>
                    <div class="text-right">
                      <button type="submit" class="btn btn-info">Submit Approval</button>
                    </div>
                  </div>
                </div>
              </div>
              
              <!-- approval akhir new department -->
              <div class="col-md-6 offset-md-6" v-if="row.ai_status == 'NMNG' && row.aa.aa_nmanager_cwid == user.cwid">
                <div class="card border">
                  <div class="card-body">
                    <h5 class="card-title">Movement Approval</h5>
                    <div class="form-group">
                      <div class="custom-control custom-radio custom-control-inline">
                        <input
                          type="radio"
                          id="approveMove"
                          class="custom-control-input"
                          value="A"
                          v-model="input.status"
                        >
                        <label
                          class="custom-control-label"
                          for="approveMove">Approve Movement
                        </label>
                      </div>
                      <div class="custom-control custom-radio custom-control-inline">
                        <input
                          type="radio"
                          id="rejectMove"
                          class="custom-control-input"
                          value="R"
                          v-model="input.status"
                        >
                        <label
                          class="custom-control-label"
                          for="rejectMove">Reject Movement
                        </label>
                      </div>
                    </div>
                    <div class="form-group" v-if="input.status == 'R'">
                      <label>Remarks <small class="txt_mandatory">*</small></label>
                      <textarea v-model="input.remarks" minlength="3" class="form-control" rows="5" :required="input.status == 'R' ? true : false"></textarea>
                    </div>
                    <div class="text-right">
                      <button type="submit" class="btn btn-info">Submit Approval</button>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
      </VForm>
    </div>
  </div>
</template>
